<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        :options="options"
        :error="error"
        :loading="loading"
    >
        <template v-slot:option="scope">
            <q-item  v-bind="scope.itemProps">
                <q-item-section avatar>
                    <q-icon :color="scope.opt.color" name="mdi-square" />
                </q-item-section>
                <q-item-section>{{ scope.opt.label }}</q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { ref, computed } from "vue";
import { useDefaultDataStore } from "@/stores/useDefaultDataStore";
import { useQuasar } from "quasar";

const loading = ref(false);
const $q = useQuasar();
const defaultDataStore = useDefaultDataStore();
const props = defineProps({
    modelValue: [String, Number],
    presupuesto: [String, Number],
});
const emit = defineEmits(["update:modelValue", "updated"]);
const options = computed(() => {
    return defaultDataStore?.getSelectEstados || [];
});
const estadoColor = computed(() => {
    return defaultDataStore?.getEstadoColor(props.modelValue);
});
</script>
